module.exports = __webpack_public_path__ + "static/section_4-09fc04f4c1d67733c8196ada9f5d1df2.png";